import React, { useEffect } from 'react';
import { useAuth } from './AuthContext';
import { isSessionValid } from './sessionUtils';

/**
 * Higher-Order Component that wraps pages to check session validity on mount
 * Automatically logs out users with expired sessions
 * 
 * Usage:
 * export default withSessionCheck(YourComponent);
 */
const withSessionCheck = (WrappedComponent) => {
    const SessionCheckedComponent = (props) => {
        const { token, logout, isAuthenticated } = useAuth();

        useEffect(() => {
            // Only check session if user is supposed to be authenticated
            if (isAuthenticated) {
                if (!isSessionValid(token)) {
                    console.log('Session expired on page load, logging out...');
                    logout();
                }
            }
        }, [token, logout, isAuthenticated]);

        // Render the wrapped component
        return <WrappedComponent {...props} />;
    };

    // Set display name for debugging
    SessionCheckedComponent.displayName = `withSessionCheck(${WrappedComponent.displayName || WrappedComponent.name})`;

    return SessionCheckedComponent;
};

export default withSessionCheck;